var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavHeader'),_c('div',{staticClass:"wrapper row-offcanvas"},[_c('NavMenu',{key:"ok",staticClass:"left-side",attrs:{"isFullScreen":false}}),_c('rightSide',{staticClass:"right-side"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }